module.exports = __webpack_public_path__ + "img/ring_g_e_null_null@2x.e6d4545c.png";